module.exports = __webpack_public_path__ + "img/mirror05.fa1e2079.jpg";